import React from "react";
import { Card } from "./ui";

/** หน้าโครงสำหรับทีมถัดไปเติม — ใส่ชื่อ/คำอธิบาย/สิ่งที่ต้องทำตาม SPEC */
export default function PlaceholderPage({ title, subtitle, spec, todo = [], children }) {
  return (
    <div>
      <div className="page-head">
        <div>
          <h1>{title}</h1>
          {subtitle ? <p>{subtitle}</p> : null}
        </div>
      </div>
      {children}
      <div className="ph-box" data-placeholder="true">
        <div className="strong">โครงหน้า — รอทีมถัดไปเติม{spec ? ` (SPEC ${spec})` : ""}</div>
        {todo.length ? <ul>{todo.map((t) => <li key={t}>{t}</li>)}</ul> : null}
      </div>
    </div>
  );
}

export function Section({ title, action, children }) {
  return (
    <section>
      <div className="section-title">
        <h2>{title}</h2>
        {action}
      </div>
      {children}
    </section>
  );
}

export function Panel({ children, ...rest }) {
  return <Card {...rest}>{children}</Card>;
}
